import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Link } from 'react-router-dom';
import Imgix from 'react-imgix';
import breakpoints from '@/constants/breakpoints';
import ArrowTwo from '../../common/ArrowTwo';

export default function NewArrivals() {
  const { colors: { french } } = useTheme();

  return (
    <Container>
      <div className="image-container">
        <Imgix
          className="image"
          imgixParams={{
            auto: 'compress,format',
            fit: 'crop',
            crop: 'focalpoint',
            'fp-x': 0.5,
            'fp-y': 0.4,
            'fp-z': 1 }}
          src="https://theinside.imgix.net/homepage/rebrand/iconic-x-bench.jpg"
          htmlAttributes={{
            loading: 'lazy',
            alt: 'new arrivals'
          }}
        />
      </div>
      <div className="text-container">
        <h2>
          <em>Most Loved</em>
        </h2>
        <p className="copy">The Iconic X Bench</p>
        <Link
          className="link"
          to="/c/living-room-furniture/ottomans"
        >
          Shop Now <ArrowTwo width={25} height={25} strokeColor={french} />
        </Link>
      </div>
    </Container>
  );
}

const Container = styled.div`
  padding: 0;
  background-color: ${props => props.theme.colors.mist};
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints['tablet']}px) {
    flex-direction: row;
    padding: 38px;
  }

  @media (min-width: ${breakpoints['desktop']}px) {
    padding: 62px 121px;
  }

  @media (min-width: ${breakpoints['large-desktop']}px) {
    padding: 86px 135px;
  }

  .image-container {
      display: block;
      flex: 1;
  }

  .image {
    width: 100%;
  }

  .text-container {
    flex: 1;
    margin: 38.7px auto 45.5px;
    text-align: center;
    max-width: 263px;

    @media (min-width: ${breakpoints['tablet']}px) {
      padding-left: 52.3px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
      max-width: unset;
    }

    h2 {
      font-size: 18px;
      line-height: 18px;
      letter-spacing: -0.36px;
      margin-bottom: 10px;
      color: ${props => props.theme.colors.french};
      font-family: ${({ theme }) => theme.fonts.secondary.family};
      letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
      font-weight: 300;
      text-align: center;

      @media (min-width: ${breakpoints['tablet']}px) {
        text-align: left;
      }

      @media (min-width: ${breakpoints['desktop']}px) {
        font-size: 26px;
        line-height: 32px;
        letter-spacing: -0.52px;
        margin-bottom: 18px;
      }

      @media (min-width: ${breakpoints['large-desktop']}px) {
        font-size: 32px;
        line-height: 32px;
        letter-spacing: -0.64px;
        margin-bottom: 34px;
      }
    }

    .copy {
      font-size: 26px;
      line-height: 32px;
      letter-spacing: -0.52px;
      margin-bottom: 18px;
      color: ${props => props.theme.colors.french};
      font-family: ${({ theme }) => theme.fonts.secondary.family};
      letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
      font-weight: 300;

      @media (min-width: ${breakpoints['desktop']}px) {
        font-size: 44px;
        line-height: 56px;
        letter-spacing: -0.88px;
        margin-bottom: 31.3px;
      }

      @media (min-width: ${breakpoints['xlarge-desktop']}px) {
        font-size: 56px;
        line-height: 65px;
        letter-spacing: -1.12px;
        margin-bottom: 43.5px;
      }
    }

    .link {
      font-size: 16px;
      color: ${props => props.theme.colors.french};
      /* font-family: ${props => props.theme.fonts.primary}; */

      @media (min-width: ${breakpoints['desktop']}px) {
        font-size: 20px;
      }
    }
  }
`;
